var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mibiBox",attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/businessOrder/goHome1.png"},on:{"click":_vm.openMini}})
}
var staticRenderFns = []

export { render, staticRenderFns }